export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
export const API_WEB_ORDERING_BASE_URL = process.env.REACT_APP_API_WEB_ORDERING_BASE_URL
export const API_API_BASE = process.env.REACT_APP_API_API_BASE
console.log(API_BASE_URL, API_BASE_URL)